import React from 'react';
import { Shimmer } from '../Shimmer/Shimmer';
import {
  Container,
  BlueHeader,
  SearchBox,
  Section,
  SectionHeader,
  TicketCardRow,
  CategoryRow
} from './ShimmerHelpCenterLandingPage.styles';
import { ShimmerHelpCenterLandingPageProps } from './ShimmerHelpCenterLandingPage.types';

const ShimmerTicketCard = () => (
  <TicketCardRow>
    <Shimmer width={200} height={14} />
    <Shimmer width={140} height={12} />
  </TicketCardRow>
);

export const ShimmerHelpCenterLandingPage = ({
  width,
  height
}: ShimmerHelpCenterLandingPageProps) => {
  return (
    <Container $width={width} $height={height}>
      <BlueHeader>
        <Shimmer width={220} height={28} baseColor="#d6d6d6" highlightColor="#e8e8e8" />
        <Shimmer width={160} height={18} baseColor="#d6d6d6" highlightColor="#e8e8e8" />
      </BlueHeader>

      <SearchBox>
        <Shimmer width="100%" height={44} borderRadius={8} />
      </SearchBox>

      <Section>
        <SectionHeader>
          <Shimmer width={100} height={16} />
          <Shimmer width={50} height={14} />
        </SectionHeader>
        {Array.from({ length: 3 }).map((_, i) => (
          <ShimmerTicketCard key={i} />
        ))}
      </Section>

      <Section>
        <Shimmer width={120} height={16} />
        {Array.from({ length: 5 }).map((_, i) => (
          <CategoryRow key={i}>
            <Shimmer width="80%" height={14} />
          </CategoryRow>
        ))}
      </Section>
    </Container>
  );
};
